export const SUBSCRIPTION_REQUIRED_MESSAGE =
  "No tienes una suscripción activa. Activa o renueva tu plan en Mi plan para registrar movimientos y hacer cambios.";

export function getApiErrorMessage(error, fallback = "No pudimos completar la operación. Inténtalo de nuevo.") {
  const detail = error?.response?.data?.detail;
  // Support the previous backend response while deployments roll out.
  if (error?.response?.status === 403 && detail === "Subscription expired. Please renew to make changes.") {
    return SUBSCRIPTION_REQUIRED_MESSAGE;
  }
  if (error?.response?.status >= 500) return fallback;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (typeof detail?.message === "string" && detail.message.trim()) return detail.message;
  return fallback;
}
